import colors from 'common/styles/colors';
import { BRAND_IDS, NTN_PRIMARY_COLOR } from 'home/DomainName/DomainConstants';

export { BRAND_IDS };

/** Identify brand from theme.brandId — not from color strings. */
export const isPetasenseBrandTheme = (theme) =>
  (theme && theme.brandId) === BRAND_IDS.PETASENSE;

export const isNtnBrandTheme = (theme) =>
  (theme && theme.brandId) === BRAND_IDS.NTN;

export const getPartnerPrimaryColor = (theme) => {
  if (theme && theme.primaryColor) {
    return theme.primaryColor;
  }
  if (isPetasenseBrandTheme(theme)) {
    return colors.green;
  }
  if (isNtnBrandTheme(theme)) {
    return NTN_PRIMARY_COLOR;
  }
  return colors.green;
};

export const getPartnerHoverTintBg = (theme) =>
  (theme && theme.hoverTintBg) || '#F8FAFC';

export const getPartnerBadgeStyles = (theme) => ({
  background: (theme && theme.badgeBackground) || '#e4f4f7',
  color: (theme && theme.badgeColor) || getPartnerPrimaryColor(theme),
});

export const getPartnerSearchInputBorder = (theme) =>
  (theme && theme.searchInputBorder) || '#acdde8';

export const getTemplateBannerTitleColor = (theme) =>
  (theme && theme.templateBannerTitleColor) || '#111827';

export const getCostSavedHighlightStyles = (theme) => ({
  backgroundColor: (theme && theme.costSavedHighlightBg) || '#EDF6FD',
  borderColor: (theme && theme.costSavedHighlightBorder) || '#B7D8EE',
  boxShadow: (theme && theme.costSavedHighlightShadow) || 'rgba(0, 131, 202, 0.25)',
});
